import './header.css'

const Header = () => {
  return (
    <div className="header">
        <div className="headerTitles">
            {/* <span className="headerTitleSm">React & Node</span> */}
            {/* <span className="headerTitleLg">Blog</span> */}
        </div>
        <img className="headerImg" src="https://img.freepik.com/premium-photo/woman-works-office-blue-background-concept-workspace-working-computer-freelance-banner_164357-1144.jpg?w=2000" alt="" />
    </div>
  )
}

export default Header
